export class Study {
    constructor(
        public id: string,
        public name: string,
        public academicYears: AcademicYear[],
        public lastStudyYear: number,
        public isTranscriptRequestable: boolean,
        public latestAppraisalDate: string
    ){}
}

export class AcademicYear {
    constructor(
        public year: number,
        public creditsEarned: number,
        public creditsTotal: number,
        public courses: Course[],
        public isOpen: boolean,
        public loaded: boolean
    ){}
}

export class Course {
    constructor(
        public name: string,
        public code: string,
        public id: string,
        public appraisalId: string,
        public period: string,
        public creditsEarned: number,
        public date: string,
        public grade: string,
        public results: PartialResult[],
        public isOpen: boolean,
        public isPassed: boolean,
        public isAppraised: boolean,
        public bookedModuleId: string
    ){}
}

export class PartialResult {
    constructor(
        public id: string,
        public date: string,
        public period: string,
        public type: string,
        public grade: string,
        public child: boolean,
        public results: PartialResult[]
    ){}
}

export class ModuleDetail {
    constructor(
        public name: string,
        public isPlanned: boolean,
        public hasResult: boolean,
        public moduleEvents: ModuleEvent[],
        public period: Period,
        public code: string,
        public credits: string,
        public hasRules: boolean,
        public isExCur: boolean,
        public examEvents: ExamEvent[],
        public isEditable: boolean,
        public hasLastMinuteRegistrations: boolean,
        public bookableNotAvailable: boolean,
        public studyLinkUrl: string
    ){}
}

export class Period {
    constructor(
        public isPlannable: boolean,
        public isBookable: boolean,
        public description: string,
        public isLastMinuteBookable: boolean
    ){}
}

export class ModuleEvent {
    constructor(
        public id: string, 
        public code: string, 
        public type: string, 
        public description: string
    ){}
}


export class ExamEvent {
    constructor(
        public id: string,
        public offerNumber: string,
        public date: string,
        public requireExtraTime: boolean,
        public extraTimeEditable: boolean
    ){}
}


export class TranscriptRequest {
    constructor(
        public requested: boolean,
        public requestId: string
    ) { }
}